<template>
<v-layout column>
  <v-layout row align-end justify-center pb-1>
    <v-flex>
      <h1 class="text-xs-center display-3">
        Escolha seu plano
      </h1>
    </v-flex>
  </v-layout>
  <v-layout row justify-center wrap>
    <v-flex xs10 sm4 lg3 xl3 
      v-for="(plan,index) in plans" :key="index" pa-2>
      <sp-plan :plan="plan"></sp-plan>
    </v-flex>
  </v-layout>
</v-layout>
</template>

<script>
  import SpPlan from '../components/SpPlan'
  export default {
    components:{
      SpPlan
    },
    data(){
      return {
        plans:[
          {
            title:"Básico",
            price:"R$99,00",
            code:'BASIC',
            items:[
              {icon:"web",text:"Web App",include:true},
              {icon:"phone_android",text:"App Android",include:true},
              {icon:"phone_iphone",text:"App iPhone",include:true}
            ]
          },
          // {
          //   title:"Premium",
          //   price:"R$159,00",
          //   items:[
          //     {icon:"web",text:"Web App",include:true},
          //     {icon:"phone_android",text:"App Android",include:true},
          //     {icon:"phone_iphone",text:"App iPhone",include:false}
          //   ]
          // },
          // {
          //   title:"Deluxe",
          //   price:"R$249,00",
          //   items:[
          //     {icon:"web",text:"Web App",include:true},
          //     {icon:"phone_android",text:"App Android",include:true},
          //     {icon:"phone_iphone",text:"App iPhone",include:true}
          //   ]
          // }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>